import { kpiApi } from "@/api/kpiApi";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Collapse,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { KpiAddNewMemberForm } from "./KpiAddNewMemberForm";
import ManageButton from "./ManageButton";

export default function KpiSettingMember() {
    const [formOpen, setFormOpen] = useState(false);
    const { kpi } = useOutletContext();
    const members = kpi?.data?.data?.stakeholder_groups
        ? _.sortBy([...kpi.data.data.stakeholder_groups], ["title"])
        : [];

    const handleOnCloseForm = () => setFormOpen(false);

    const [addKpiStakeholder, addKpiStakeholderResponsej] = kpiApi.endpoints.addKpiStakeholder.useMutation();
    const [deleteKpiStakeholder, deleteKpiStakeholderResponse] = kpiApi.endpoints.deleteKpiStakeholder.useMutation();
    const handleAddMember = (groupId) =>
        addKpiStakeholder({
            id: kpi?.data?.data?.id,
            stakeholderGroupIds: [groupId],
        });
    const handleRemoveMember = (groupId) =>
        deleteKpiStakeholder({
            id: kpi?.data?.data?.id,
            stakeholderGroupIds: [groupId],
        });

    return (
        <Card variant="outlined">
            <CardHeader
                title={`Members (${members.length ?? "-"})`}
                action={
                    <Button variant="outlined" onClick={() => setFormOpen((prev) => !prev)}>
                        Add
                    </Button>
                }
            ></CardHeader>
            <Divider variant="middle" />
            <CardContent>
                <Collapse in={formOpen}>
                    <Box sx={{ marginBottom: 2 }}>
                        <KpiAddNewMemberForm
                            kpi={kpi}
                            handleOnCloseForm={handleOnCloseForm}
                            handleAddMember={handleAddMember}
                        />
                    </Box>
                </Collapse>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>name</TableCell>
                            <TableCell>description</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {members.map((group) => (
                            <TableRow key={group.id}>
                                <TableCell>
                                    <Typography>{group.title}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography color="gray">{group.description}</Typography>
                                </TableCell>
                                <TableCell sx={{ textAlign: "right" }}>
                                    <ManageButton onClickDeleteMember={() => handleRemoveMember(group.id)} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}
